import { Star, Quote } from 'lucide-react';

/**
 * Curated Google reviews. To update: edit this array, redeploy.
 * Source: Google Business profile reviews.
 */
const REVIEWS = [
  {
    id: 'review-jan',
    name: 'Jan',
    rating: 5,
    text: "I was very happy with Clare. She looked after our 6 cats so well. Will use Maid for Cats again. Highly recommend!!",
  },
  {
    id: 'review-lindsay',
    name: 'Lindsay',
    rating: 5,
    text: "Absolutely fantastic — was really unsure about having a stranger come in, but upon meeting Rob he came and did a meet and greet and met Bella. I went away and felt at ease knowing she would be looked after. I received photos daily and even a video which was lovely. Highly recommend this company — they're definitely top of my list if I need cat sitting again. Thanks Rob and Clare.",
  },
  {
    id: 'review-alison',
    name: 'Alison',
    rating: 5,
    text: "Maid for Cats took fantastic care of our elderly cat (aged 20), who has health issues and has daily meds. We got daily photos / updates and it was clear that she was being very well looked after, like she was their own. Very professional and caring service — would 100% recommend.",
  },
];

const StarRow = ({ count = 5 }) => (
  <div className="reviews-stars" aria-label={`${count} out of 5 stars`}>
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} size={18} fill="#d4a52a" stroke="#d4a52a" />
    ))}
  </div>
);

const CustomerReviews = () => {
  return (
    <section className="reviews-section" data-testid="customer-reviews">
      <div className="container">
        <div className="reviews-header">
          <h2 className="section-title">What Our Customers Say</h2>
          <div className="reviews-rating-summary">
            <StarRow count={5} />
            <span className="reviews-rating-text">Rated 5 stars on Google</span>
          </div>
        </div>

        <div className="reviews-grid">
          {REVIEWS.map((review) => (
            <article
              key={review.id}
              className="review-card"
              data-testid={`review-card-${review.id}`}
            >
              <Quote className="review-quote-icon" size={28} aria-hidden="true" />
              <StarRow count={review.rating} />
              <p className="review-text">"{review.text}"</p>
              <div className="review-author">— {review.name}</div>
            </article>
          ))}
        </div>

        <div className="reviews-cta">
          <a
            href="https://g.page/r/CZIipnthC_CTEBI"
            target="_blank"
            rel="noopener noreferrer"
            className="reviews-google-link"
            data-testid="reviews-read-more-google"
          >
            Read more reviews on Google →
          </a>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviews;
